"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevels;
(function (LogLevels) {
    LogLevels["DEBUG"] = "debug";
    LogLevels["INFO"] = "info";
    LogLevels["WARN"] = "warn";
    LogLevels["ERROR"] = "error";
    LogLevels["FATAL"] = "fatal";
})(LogLevels = exports.LogLevels || (exports.LogLevels = {}));
//# sourceMappingURL=log-levels.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuejs-logger/dist/enum/log-levels.js
// module id = 1747
// module chunks = 0